import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Event from "./Event";

export default class ContentModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            title: '',
            content: '',
            type: 'text'
        };
    }

    componentWillMount() {
        Event.on('contentModal.show', (data) => {
            this.setState({ show: true, title: data.title, content: data.content, type: data.type ? data.type : 'text' });
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({ show: false });
        }, this._rootNodeID);
    }

    componentWillReceiveProps(props) {
        this.setState({
            show: props.show,
            title: props.title,
            content: props.content,
            type: props.type ? props.type : 'text'
        });
    }

    componentWillUnmount() {
        Event.off('contentModal.show', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    toggle() {
        this.setState({ show: !this.state.show });
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle()}>
                <ModalHeader toggle={() => this.toggle()}>
                    {this.state.title}
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-xs-12">
                            {this.state.type == 'text' ? <p>{this.state.content}</p> : null}
                            {this.state.type == 'html' ?
                                <div dangerouslySetInnerHTML={{ __html: this.state.content }}></div> : null}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}